export const RESIGNATION_SERVICE_TYPE = 9;
